// @ts-nocheck
import {
  BarChart3 as BarChartIcon,
  FileText as FileIcon,
  HelpCircle as HelpIcon,
  Home as HomeIcon,
  List as ListIcon,
  Route as RouteIcon,
  Settings as SettingsIcon
} from "lucide-react";

export type SubLinkConfig = {
  title: string;
  url: string;
  permission?: string;
};

export type NavLinkConfig = {
  title: string;
  url: string;
  id?: string;
  icon?: React.ComponentType<{ size?: number }>;
  subLinks?: SubLinkConfig[];
};

export const SIDEBAR_LINKS: NavLinkConfig[] = [
  {
    title: "Home",
    url: "/home/dashboard",
    icon: HomeIcon
  },
  {
    title: "Client List",
    url: "/home/clientsList",
    icon: ListIcon
  },
  {
    title: "Roadmaps",
    url: "/home/roadmaps",
    icon: RouteIcon,
    subLinks: [
      { title: "Create a Roadmap", url: "/home/roadmaps/createRoadMap" },
      { title: "View Past Roadmaps", url: "/home/roadmaps/pastRoadmaps" }
    ]
  },
  {
    title: "Performance",
    url: "/home/firmPerformance",
    icon: BarChartIcon,
    subLinks: [
      { title: "Revenue", url: "/home/firmPerformance/revenue" },
      { title: "Onboarding", url: "/home/firmPerformance/onboarding" },
      { title: "Proposals", url: "/home/firmPerformance/proposals" },
      { title: "Survey", url: "/home/firmPerformance/survey" },
      { title: "Churn", url: "/home/firmPerformance/churns" }
    ]
  },
  {
    title: "Resources",
    id: "Resources",
    url: "https://portal.smartpath.co/users/sign_in",
    icon: FileIcon
  },
  {
    title: "Setup",
    url: "/home/settings",
    icon: SettingsIcon,
    subLinks: [
      { title: "Pricing Customization", url: "/home/settings/pricing" },
      { title: "Branding", url: "/home/settings/branding" },
      {
        title: "Magic Client Pricing Settings",
        url: "/home/settings/magicClientPricingSettings",
        permission: "Manage Survey Settings"
      },
      {
        title: "Onboarding Checklists",
        url: "/home/settings/manageDeliveryChecklist"
      },
      {
        title: "Client Facing Questions",
        url: "/home/settings/clientFacingQuestions",
        permission: "Manage Survey Settings"
      },
      { title: "Integrations", url: "/home/settings/integrations" },
      { title: "Document Templates", url: "/home/settings/documentTemplates" },
      { title: "Email Templates", url: "/home/settings/emailTemplates" },
      { title: "Auto-Reminders", url: "/home/settings/reminder" },
      { title: "Manage Users", url: "/home/settings/manageUsers" }
    ]
  },
  {
    title: "Help Center",
    id: "Help_Center",
    url: "https://help.smartpath.co/en/",
    icon: HelpIcon
  }
];

export const EXTERNAL_LINK_TITLES = new Set(["Resources", "Help Center"]);

export const isExternalLink = (archive: NavLinkConfig): boolean =>
  EXTERNAL_LINK_TITLES.has(archive.title);
